<!--
 * @Author: your name
 * @Date: 2020-02-26 21:55:59
 * @LastEditTime: 2020-03-20 14:42:47
 * @LastEditors: OBKoro1
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/Result1.vue
 -->
<template>
  <div class="result2">
    <div class="header">
        <img src="../assets/head4.png">
        <div class="title">
          <p class="title_1">抑郁自测量表评测结果</p>
        </div>
    </div>

    <div class="body">
        <div class="part_1">
            <p>根据中国常模测试结果</p>
            <p>你的测试结果为<span class="fen">{{ score }}</span>分</p>
            <p class="description">结果说明</p>
            <p class="description">按中国常模结果，你抑郁评定的分界值总的正常粗分上限为41分，标准分 上限为53分，标准分低于53分，说明你心理状况正常，超过标准分53分说明你有抑郁症状，分值越高，说明您的抑郁症状越严重，需要接受心理咨询甚至需要在医生指导下服药。53-62分为轻度抑郁，63-72分为中度抑郁，73分以上为重度抑郁</p>
            <p class="description2">轻度焦虑: 53—62分</p>
            <p class="description2">中度焦虑: 63—72分</p>
            <p class="description2">重度焦虑: 73分以上</p>
        </div>
        <div class="part_2">
            <p class="colorBlue">本测试仅供参考</p>
            <p class="colorBlue">你是否需要专业咨询为您服务</p>
            <p class="yes" @click="goApply()">是</p>
            <p class="no" @click="goIndex()">否</p>
        </div>
    </div>
     <div class="footer3"  @click="goback()">
      <img class="goback" src="../assets/goback.png" >
    </div>
    <share></share>
  </div>
</template>

<script>
import { Http } from '@/utils/http.js'
import api   from '@/config/api.js'
// import validator from '@/utils/validator.js'
import Cookies from 'js-cookie'
// import AreaList from '@/utils/area'
// import { pca, pcaa } from 'area-data'
import axios from 'axios'


export default {
  name: 'Result2',
  data() {
    return {
        score: 0
    };
  },

  methods: {
      // 返回上一页
    goback(){
      this.$router.push({ name: "QuestionList"})
    },
     // 去申请页
    goApply(){
       this.$router.push({ name: "Apply"})
    },
    // 去首页
    goIndex(){
      this.$router.push({ name: "Index"})
    }
  },
  mounted: function() {
    this.score = this.$route.query.score
  }

};
</script>

<style lang="less">
.result2 {
  font-size: 16px;
  .header {
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .title {
      .title_1 {
        position: absolute;
        width: 40%;
        top: 20px;
        font-size: 20px;
        left: 30px;
        color: #34afe8;
      }
    }
  }
  .body {
    margin-top: 12px;
    margin-left: 32px;
    margin-right: 32px;
    .part_1 {
        .fen {
            font-size: 24px;
            color: #34afe8;
        }
        .description{
           font-size: 12px;
          color: #888888;
           margin-block-start: 0;
          margin-block-end: 0;
        }
        .description2{
          margin-block-start: 0;
          margin-block-end: 0;
          font-size: 12px;
          color: #34afe8;
        }
        
    }
    .part_2 {
            width: 80%;
    margin: 20px auto;
    text-align: center;
        text-align: center;
        box-shadow: 0 5px 10px #888888;
        padding-bottom: 12px;
        padding-top: 12px;
        .colorBlue {
            color: #34afe8;
        }
        .yes {
            color: #fff;
            width: 48px;
            margin-left: 42%;
            background-color: #1199d8;
            border: 2px solid;
            border-radius: 25px;
        }
        .no {
            color: #fff;
            width: 48px;
            margin-left: 42%;
            background-color: #828d92;
            border: 2px solid;
            border-radius: 25px;
        }
    }
  }

   .footer3 {
      position: fixed;
      bottom: 0px;
      right: 0;
      img {
        width: 80px;
        background: #34afe8;
        border: 1px dotted #34afe8;
        -webkit-border-radius: 50%;
        border-radius: 10%;
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Result2.vue